export default __webpack_public_path__ + "dbd000f4ad99689cfc80d4cb97b93b27.glb";